import FieldString from "../../string/string"

import FieldConfig from "../../../proto/field-config"
import FieldTimeDuration_FormElementView from "./render/form-element-view"
import TimeUtils from "../../../../gd/utils/time"

const debug = false
// const debug = "FieldTimeDuration"

export default class FieldTimeDuration extends FieldString {

    constructor(config:FieldConfig) {
        super(config)

        this.typeLabel      = "Custom time"
        this.icon           = 'i5-my-time'

        this.renderComponents.formElementView = FieldTimeDuration_FormElementView
    }

    getDisplayValue(value: any): any {
        debug && console.log(debug, 'getDisplayValue', value)

        if (value) {
            value = TimeUtils.convertToTimeString(value)
        }

        return value
    }

    normalizeValue(value: any): any {
        debug && console.log(debug, 'normalizeValue', value)

        return TimeUtils.convertToMinutes(value)
    }
}
